import { createSlice } from "@reduxjs/toolkit";
import { getRolePermissions, getUserPermissions } from "./rolePermissionThunk";

const buildPermissionMap = (data = []) => {
    const map = {};

    data.forEach((base) => {
        map[`base:${base.BaseNavigationId}`] = {
            create: base.CanCreate,
            modify: base.CanModify,
            delete: base.CanDelete,
            view: base.CanView,
            print: base.CanPrint,
            mail: base.CanMail,
        };

        base.NavigationDetailsList?.forEach((nav) => {
            map[`nav:${nav.NavigationId}`] = {
                create: nav.CanCreate,
                modify: nav.CanModify,
                delete: nav.CanDelete,
                view: nav.CanView,
                print: nav.CanPrint,
                mail: nav.CanMail,
            };

            nav.SubNavigationDetailsList?.forEach((sub) => {
                map[`sub:${sub.SubNavigationId}`] = {
                    create: sub.CanCreate,
                    modify: sub.CanModify,
                    delete: sub.CanDelete,
                    view: sub.CanView,
                    print: sub.CanPrint,
                    mail: sub.CanMail,
                };
            });
        });
    });

    return map;
};

const initialState = {
    permissions: [],
    map: {},

    navigationUserPermissions: [],
    navigationUserMap: {},

    loading: false,
    userLoading: false,
    userLoaded: false,

    error: null,
    userError: null,
};

const rolePermissionSlice = createSlice({
    name: "rolePermissions",
    initialState,
    reducers: {
        clearPermissions: (state) => {
            state.permissions = [];
            state.navigationUserPermissions = [];
            state.navigationUserMap = {};
            state.userLoaded = false;
            state.error = null;
            state.userError = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Role Permissions
            .addCase(getRolePermissions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getRolePermissions.fulfilled, (state, action) => {
                state.loading = false;
                state.permissions = action.payload;
                state.map = buildPermissionMap(action.payload);
            })
            .addCase(getRolePermissions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // User Permissions
            .addCase(getUserPermissions.pending, (state) => {
                state.userLoading = true;
                state.userLoaded = false;
                state.userError = null;
            })
            .addCase(getUserPermissions.fulfilled, (state, action) => {
                state.userLoading = false;
                state.userLoaded = true;
                state.navigationUserPermissions = action.payload;
                state.navigationUserMap = buildPermissionMap(action.payload);
            })
            .addCase(getUserPermissions.rejected, (state, action) => {
                state.userLoading = false;
                state.userLoaded = true;
                state.userError = action.payload;
            });
    },
});

export const { clearPermissions } = rolePermissionSlice.actions;

export default rolePermissionSlice.reducer;
